export const getCampaignPricing = {
  GET_CAMPIAGN_PRICING_REQUEST: "GET_CAMPIAGN_PRICING_REQUEST",
  GET_CAMPIAGN_PRICING_SUCCESS: "GET_CAMPIAGN_PRICING_SUCCESS",
  GET_CAMPIAGN_PRICING_ERROR: "GET_CAMPIAGN_PRICING_ERROR",
};
